module.exports = __webpack_public_path__ + "static/img/vtrl-about-img.6d954a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vtrl-about-img.jpg
// module id = oAH8
// module chunks = 1